export enum AssetTypes {
    All = 1,
    Franchise,
    Division,
    Historical
}
